export enum avatarInteractionTypes {
  GO_TO_PROFILE,
  UPLOAD_AVATAR,
  NONE
}
